module.exports = __webpack_public_path__ + "static/media/hero-jewelry.e4f1ebe7.png";